import axios from 'src/utils/axios';
import helpers from 'src/helpers';
import { NOTIFICATION_STATUS } from 'src/constants';
import { addNotification } from 'src/actions/notificationActions';
import { getAccountInfo } from 'src/actions/accountActions';

export const GET_MESSAGE_SEND_HOURS = '@messaging-settings/get-message-send-hours';
export const GET_MESSAGE_SEND_HOURS_SUCCESS = '@messaging-settings/get-message-send-hours-success';
export const GET_MESSAGE_SEND_HOURS_ERROR = '@messaging-settings/get-message-send-hours-error';

export const UPDATE_MESSAGE_SEND_HOURS = '@messaging-settings/update-message-send-hours';
export const UPDATE_MESSAGE_SEND_HOURS_SUCCESS = '@messaging-settings/update-message-send-hours-success';
export const UPDATE_MESSAGE_SEND_HOURS_ERROR = '@messaging-settings/update-message-send-hours-error';

export const GET_KEYWORDS_LIST = '@messaging-settings/get-keywords-list';
export const GET_KEYWORDS_LIST_SUCCESS = '@messaging-settings/get-keywords-list-success';
export const GET_KEYWORDS_LIST_ERROR = '@messaging-settings/get-keywords-list-error';
export const CLEAR_KEYWORDS_LIST = '@messaging-settings/clear-keywords-list';

export const GET_KEYWORD = '@messaging-settings/get-keyword';
export const GET_KEYWORD_SUCCESS = '@messaging-settings/get-keyword-success';
export const GET_KEYWORD_ERROR = '@messaging-settings/get-keyword-error';

export const GET_FOLLOW_UP_MESSAGES = '@messaging-settings/get-follow-up-messages';
export const GET_FOLLOW_UP_MESSAGES_SUCCESS = '@messaging-settings/get-follow-up-messages-success';
export const GET_FOLLOW_UP_MESSAGES_ERROR = '@messaging-settings/get-follow-up-messages-error';

export const CREATE_KEYWORD = '@messaging-settings/create-keyword';
export const CREATE_KEYWORD_SUCCESS = '@messaging-settings/create-keyword-success';
export const CREATE_KEYWORD_ERROR = '@messaging-settings/create-keyword-error';

export const UPDATE_KEYWORD = '@messaging-settings/update-keyword';
export const UPDATE_KEYWORD_SUCCESS = '@messaging-settings/update-keyword-success';
export const UPDATE_KEYWORD_ERROR = '@messaging-settings/update-keyword-error';

export const CHANGE_KEYWORD_STATUS = '@messaging-settings/change-keyword-status';
export const CHANGE_KEYWORD_STATUS_SUCCESS = '@messaging-settings/change-keyword-status-success';
export const CHANGE_KEYWORD_STATUS_ERROR = '@messaging-settings/change-keyword-status-error';

export const DELETE_KEYWORD = '@messaging-settings/delete-keyword';
export const DELETE_KEYWORD_SUCCESS = '@messaging-settings/delete-keyword-success';
export const DELETE_KEYWORD_ERROR = '@messaging-settings/delete-keyword-error';
export const CLEAR_KEYWORD_WAS_DELETED = '@messaging-settings/clear-keyword-was-deleted';

export const REPLACE_SYSTEM_GEN_MESSAGE = '@messaging-settings/replace-system-gen-message';
export const REPLACE_SYSTEM_GEN_MESSAGE_SUCCESS = '@messaging-settings/replace-system-gen-message-success';
export const REPLACE_SYSTEM_GEN_MESSAGE_ERROR = '@messaging-settings/replace-system-gen-message-error';

export const CLEAR_KEYWORD_DETAILS = '@messaging-settings/clear-keyword-details';

export const SET_CURRENT_NAVIGATION_TAB = '@messaging-settings/set-current-navigation-tab';
export const SET_KEYWORD_DETAILS_VIEW_TAB = '@messaging-settings/set-keyword-details-view-tab';
export const SET_SELECTED_KEYWORDS = '@messaging-settings/set-selected-keywords';
export const SET_KEYWORDS_QUERY = '@messaging-settings/set-keywords-query';
export const SET_BACK_TO_KEYWORDS_LIST = '@messaging-settings/set-back-to-keywords-list';
export const SET_VALUES_FORM_SEND_TEXT = '@messaging-settings/set-values-form-send-text';

export const GET_AUTO_READ_KEYWORD_SETTING = '@messaging-settings/get-auto-read-keyword-setting';
export const GET_AUTO_READ_KEYWORD_SETTING_SUCCESS = '@messaging-settings/get-auto-read-keyword-setting-success';
export const GET_AUTO_READ_KEYWORD_SETTING_ERROR = '@messaging-settings/get-auto-read-keyword-setting-error';

export const UPDATE_AUTO_READ_KEYWORD_SETTING = '@messaging-settings/update-auto-read-keyword-setting';
export const UPDATE_AUTO_READ_KEYWORD_SETTING_SUCCESS = '@messaging-settings/update-auto-read-keyword-setting-success';
export const UPDATE_AUTO_READ_KEYWORD_SETTING_ERROR = '@messaging-settings/update-auto-read-keyword-setting-error';

export const setCurrentNavigationTab = (tabName) => ({
  type: SET_CURRENT_NAVIGATION_TAB,
  payload: tabName
});

export const setKeywordDetailsViewTab = (tabName) => async (dispatch) => {
  dispatch({
    type: SET_KEYWORD_DETAILS_VIEW_TAB,
    payload: tabName
  });
};

export const setKeywordsQuery = (query) => ({
  type: SET_KEYWORDS_QUERY,
  payload: query
});

export const getMessageSendHours = (type) => async (dispatch) => {
  console.log(`INSIDE getMessageSendHours, type = ${type}`);
  dispatch({
    type: GET_MESSAGE_SEND_HOURS,
  });
  try {
    const response = await axios.get(`/api/messaging-settings/automated-message-send-times/${type}`);
    console.log(`response.data = ${JSON.stringify(response?.data, null, 2)}`);
    dispatch({
      type: GET_MESSAGE_SEND_HOURS_SUCCESS,
      payload: response?.data || {}
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_MESSAGE_SEND_HOURS_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_MESSAGE_SEND_HOURS_ERROR,
    });
  }
};

export const updateMessageSendHours = (payload, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch({
      type: UPDATE_MESSAGE_SEND_HOURS,
    });
    const response = await axios.put('/api/messaging-settings/automated-message-send-times', { userMessageSendTimesChanges: payload });
    const {
      id,
    } = response?.data || {};

    dispatch(addNotification(UPDATE_MESSAGE_SEND_HOURS_SUCCESS, 'Send Hours have been successfully updated', NOTIFICATION_STATUS.SUCCESS));
    dispatch({
      type: UPDATE_MESSAGE_SEND_HOURS_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry(id);
    }
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    dispatch(addNotification(UPDATE_MESSAGE_SEND_HOURS_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: UPDATE_MESSAGE_SEND_HOURS_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const getAllKeywordsList = (isPaginationDisabled = false) => async (dispatch, getState) => {
  dispatch({
    type: GET_KEYWORDS_LIST,
  });
  try {
    const query = getState()?.messagingSettings?.keywordsQuery || {};
    const params = {
      ...query,
      count: undefined,
      isPaginationDisabled,
      ...(isPaginationDisabled && { page: undefined, pageSize: undefined }),
    };
    const response = await axios.get('/api/messaging-settings/keywords', { params });
    dispatch({
      type: GET_KEYWORDS_LIST_SUCCESS,
      payload: response?.data || [],
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_KEYWORDS_LIST_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_KEYWORDS_LIST_ERROR,
    });
  }
};

export const getKeyword = (keywordId) => async (dispatch) => {
  dispatch({
    type: GET_KEYWORD,
  });
  try {
    const response = await axios.get(`/api/messaging-settings/keywords/${keywordId}`);
    dispatch({
      type: GET_KEYWORD_SUCCESS,
      payload: response?.data || {}
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_KEYWORD_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_KEYWORD_ERROR,
    });
  }
};

export const createKeyword = (payload, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch({
      type: CREATE_KEYWORD,
    });
    const response = await axios.post('/api/messaging-settings/keywords', payload);
    const {
      id,
      name,
    } = response?.data || {};

    if (!id) {
      dispatch(addNotification(CREATE_KEYWORD_ERROR, 'Cannot create keyword', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: CREATE_KEYWORD_ERROR,
      });
      return;
    }

    dispatch(addNotification(CREATE_KEYWORD_SUCCESS, `Keyword ${name} has been successfully created`, NOTIFICATION_STATUS.SUCCESS));
    dispatch({
      type: CREATE_KEYWORD_SUCCESS,
    });
    dispatch(getAccountInfo());

    if (doWhenTry) {
      doWhenTry(id);
    }
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    dispatch(addNotification(CREATE_KEYWORD_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: CREATE_KEYWORD_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const updateKeyword = (payload, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch({
      type: UPDATE_KEYWORD,
    });
    const response = await axios.put('/api/messaging-settings/keywords', payload);
    const {
      id,
    } = response?.data || {};

    dispatch(addNotification(UPDATE_KEYWORD_SUCCESS, 'Keyword has been successfully updated', NOTIFICATION_STATUS.SUCCESS));
    dispatch({
      type: UPDATE_KEYWORD_SUCCESS,
    });
    dispatch(getAccountInfo());

    if (doWhenTry) {
      doWhenTry(id);
    }
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    dispatch(addNotification(UPDATE_KEYWORD_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: UPDATE_KEYWORD_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const changeKeywordStatus = (payload, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  dispatch({
    type: CHANGE_KEYWORD_STATUS,
  });
  try {
    const response = await axios.patch('/api/messaging-settings/keywords', payload);
    const isSuccess = response?.data?.success;

    if (!isSuccess) {
      dispatch(addNotification(CHANGE_KEYWORD_STATUS_ERROR, 'Cannot change keyword status', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: CHANGE_KEYWORD_STATUS_ERROR,
      });
      return;
    }

    dispatch(addNotification(CHANGE_KEYWORD_STATUS_SUCCESS, 'Keyword status has been successfully changed', NOTIFICATION_STATUS.SUCCESS));
    dispatch({
      type: CHANGE_KEYWORD_STATUS_SUCCESS,
    });
    dispatch(getAccountInfo());

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(CHANGE_KEYWORD_STATUS_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: CHANGE_KEYWORD_STATUS_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const deleteKeyword = (keywordIds = [], cancelRedirectToKeywordsList = false, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  dispatch({
    type: DELETE_KEYWORD,
  });
  try {
    const response = await axios.delete('/api/messaging-settings/keywords', {
      data: { ids: keywordIds },
    });
    const isSuccess = response?.data?.success;

    if (!isSuccess) {
      dispatch(addNotification(DELETE_KEYWORD_ERROR, 'Cannot delete keyword', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: DELETE_KEYWORD_ERROR,
      });
      return;
    }

    dispatch(addNotification(DELETE_KEYWORD_SUCCESS, 'Keyword has been successfully deleted', NOTIFICATION_STATUS.SUCCESS));
    dispatch({
      type: DELETE_KEYWORD_SUCCESS,
      payload: { cancelRedirectToKeywordsList },
    });
    dispatch(getAccountInfo());

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(DELETE_KEYWORD_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: DELETE_KEYWORD_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

// CON-1621 — contexts limits the picker to template scopes that can
// actually resolve on this surface's send path. Omitted means the server
// returns contact scope only (fail closed).
export const getFollowUpMessages = (contexts = null) => async (dispatch) => {
  try {
    dispatch({
      type: GET_FOLLOW_UP_MESSAGES,
    });
    const { data } = await axios.post('/api/followupmessages/template-tag', contexts ? { contexts } : {}) || {};
    const { error } = data || {};

    if (error) {
      dispatch({
        type: GET_FOLLOW_UP_MESSAGES_ERROR,
      });
      return;
    }

    dispatch({
      type: GET_FOLLOW_UP_MESSAGES_SUCCESS,
      payload: data?.messages,
    });
  } catch (e) {
    dispatch({
      type: GET_FOLLOW_UP_MESSAGES_ERROR,
    });
  }
};

export const clearFollowUpMessages = () => ({
  type: GET_FOLLOW_UP_MESSAGES_SUCCESS,
});

export const replaceSystemGenMessage = (systemGenMessage, dynamicFieldsObj) => async (dispatch) => {
  try {
    dispatch({
      type: REPLACE_SYSTEM_GEN_MESSAGE,
    });
    const { data } = await axios.post('/api/contacts/replace-system-gen-message', {
      systemGenMessage,
      ...dynamicFieldsObj,
    }) || {};

    dispatch({
      type: REPLACE_SYSTEM_GEN_MESSAGE_SUCCESS,
      payload: data?.message,
    });
  } catch (e) {
    dispatch({
      type: REPLACE_SYSTEM_GEN_MESSAGE_ERROR,
    });
  }
};

export const clearKeywordsList = () => async (dispatch) => {
  dispatch({
    type: CLEAR_KEYWORDS_LIST,
  });
};

export const clearKeywordWasDeleted = () => async (dispatch) => {
  dispatch({
    type: CLEAR_KEYWORD_WAS_DELETED,
  });
};

export const clearKeywordDetails = () => async (dispatch) => {
  dispatch({
    type: CLEAR_KEYWORD_DETAILS,
  });
};

export const setBackToKeywordsList = (payload) => ({
  type: SET_BACK_TO_KEYWORDS_LIST,
  payload,
});

export const clearBackToKeywordsList = (clearAll = false) => ({
  type: SET_BACK_TO_KEYWORDS_LIST,
  payload: !clearAll ? {
    keywords: [],
    keywordsQuery: {},
  } : false,
});

export const setSelectedKeywords = (selectedKeywords) => ({
  type: SET_SELECTED_KEYWORDS,
  payload: selectedKeywords
});

export const setValuesFormSendText = (values) => ({
  type: SET_VALUES_FORM_SEND_TEXT,
  payload: values
});

export const getAutoReadKeywordSetting = () => async (dispatch) => {
  dispatch({
    type: GET_AUTO_READ_KEYWORD_SETTING,
  });
  try {
    const response = await axios.get('/api/messaging-settings/keywords/auto-read-setting');
    dispatch({
      type: GET_AUTO_READ_KEYWORD_SETTING_SUCCESS,
      payload: response?.data?.autoReadKeywordReplies || false,
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_AUTO_READ_KEYWORD_SETTING_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_AUTO_READ_KEYWORD_SETTING_ERROR,
    });
  }
};

export const updateAutoReadKeywordSetting = (autoReadKeywordReplies) => async (dispatch) => {
  dispatch({
    type: UPDATE_AUTO_READ_KEYWORD_SETTING,
  });
  try {
    const response = await axios.patch('/api/messaging-settings/keywords/auto-read-setting', {
      autoReadKeywordReplies,
    });
    dispatch({
      type: UPDATE_AUTO_READ_KEYWORD_SETTING_SUCCESS,
      payload: response?.data?.autoReadKeywordReplies || false,
    });
    dispatch(addNotification(
      UPDATE_AUTO_READ_KEYWORD_SETTING_SUCCESS,
      autoReadKeywordReplies
        ? 'Keyword replies will now be automatically marked as read'
        : 'Keyword replies will now appear as unread',
      NOTIFICATION_STATUS.SUCCESS
    ));
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(UPDATE_AUTO_READ_KEYWORD_SETTING_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: UPDATE_AUTO_READ_KEYWORD_SETTING_ERROR,
    });
  }
};
